module.exports = __webpack_public_path__ + "media/images/ecalls/03_reasons_risk-a90aa7d6b4bdbc8b43067a2edd4f9423.png";